import React from "react";
import "./Hvideo.css";

const Hvideo = () => {
  return (
    <>
      <div
        id="rs-latest-news-style7"
        className="rs-latest-news-style7 sec-spacer"
      >
        <div className="container">
          <div className="row ">
            <h2 className="title text-center pb-50 md-pb-30   ">
            🎥 Videos{" "}
              <strong style={{ color: "#f7b205" }}>TopFaculty.co.in</strong>
            </h2>

            <div className="col-lg-1">
              </div>

              <div className="col-lg-5">
            {/* <div className="video-grid"> */}
              <div className="video-card">
                <iframe
                  src="https://www.youtube.com/embed/H_TKxQBomGA?si=pqa5QdsCs8MQNM6z"
                  title="Video 2"
                  allowFullScreen=""
                />
                <div className="video-info">
                  <p className="video-title">🎥 TopFaculty.co.in</p>
                </div>
              </div>
            {/* </div> */}
            </div>

             <div className="col-lg-5">
            {/* <div className="video-grid"> */}
              <div className="video-card">
                <iframe
                  src="https://www.youtube.com/embed/bn7wdy4OFbE?si=iI3Hb1A_7T-zcX2P"
                  title="Video 2"
                  allowFullScreen=""
                />
                <div className="video-info">
                  <p className="video-title">🎥 TopFaculty.co.in</p>
                </div>
              </div>
            {/* </div> */}
            </div>

            <div className="col-lg-1">
              </div>

          </div>
        </div>
      </div>







        <div
        id="rs-learning-objectives"
        className="rs-learning-objectives pt-4 pb-10"
      >
        <div className="container">
          <div className="sec-title mb-50">
            <h2>EXPLORE FEATURED</h2>
            <p>
              I must explain to you how all this mistaken idea of denouncing
              pleasure.
            </p>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="courses-item">
                <i className="glyph-icon flaticon-tool" />
                <h4 className="courses-title">
                  <a href="#">Expert Educators </a>
                </h4>
                <p>Learn from highly qualified teachers across India.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="courses-item">
                <i className="glyph-icon flaticon-book" />
                <h4 className="courses-title">
                  <a href="#">Customized Learning </a>
                </h4>
                <p>
                  Choose between full courses or specific topics as per your
                  need.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="courses-item">
                <i className="glyph-icon flaticon-people" />
                <h4 className="courses-title">
                  <a href="#">Flexible Scheduling </a>
                </h4>
                <p>Study or teach at your convenience with no fixed timings.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="courses-item">
                <i className="glyph-icon flaticon-diploma" />
                <h4 className="courses-title">
                  <a href="#">Affordable Education </a>
                </h4>
                <p>Quality learning at competitive prices for all students.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="courses-item">
                <i className="glyph-icon flaticon-tool-1" />
                <h4 className="courses-title">
                  <a href="#"> Live & Recorded Sessions </a>
                </h4>
                <p>
                  Access interactive live classes and revisit recorded lessons
                  anytime.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="courses-item">
                <i className="flaticon-book-1" />
                <h4 className="courses-title">
                  <a href="#">Seamless Online Platform </a>
                </h4>
                <p>
                  Easy-to-use interface for students, teachers, and coaching
                  institutes.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="courses-item">
                <i className="flaticon-book-1" />
                <h4 className="courses-title">
                  <a href="#">Coaching Institute</a>
                </h4>
                <p>Onboard teachers, manage students, and grow digitally.</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="courses-item">
                <i className="flaticon-book-1" />
                <h4 className="courses-title">
                  <a href="#">Performance Tracking </a>
                </h4>
                <p>Monitor progress with assignments and assessments.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

{/* <div className="video-grid"> */}
              {/* <div className="video-card">
                <iframe
                  src="https://www.youtube.com/embed/H_TKxQBomGA?si=pqa5QdsCs8MQNM6z"
                  title="Video 2"
                  allowFullScreen=""
                />
                <div className="video-info">
                  <p className="video-title">🎥 TopFaculty.co.in</p>
                </div>
              </div> */}
            {/* </div> */}
    </>
  );
};

export default Hvideo;
